import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        name: 'attempt-authorizations-index',
        path: '/attempt-authorizations',
        component: () => import('@/pages/attempt-authorizations/AttemptAuthorizationsIndex.vue'),
        props: true,
        meta: {
            title: 'AttemptAuthorizations',
            dataTablePage: true,
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view all', subject: 'attempt authorizations' },
        },
    },
];
